import React, { useState, useEffect } from "react";

import { Col, Row, Card, Form, Button } from "@themesberg/react-bootstrap";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";

import { dropdownItems } from "../../data/tables";
import axios from "axios";
import { createVendor, getVendor, updateVendor } from "../../app/api";
import Loader from "../../components/Loader";
import Loadericon from "../../components/Loadericon";
import{useCreateVendorMutation, useUpdateVendorMutation }from "../../store/app/apislice"

export default () => {
  const { id } = useParams();
  const history = useHistory();
  const [createVendor] = useCreateVendorMutation();
  const [updateVendor] = useUpdateVendorMutation();
  const [vendorName, setVendorName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [position, setPosition] = useState("");
  const [worklocation, setWorkLocation] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);

    const vendorData = {
      contact_person: vendorName,
      phone: phoneNumber,
      company_name: company,
      email,
      address,
      position,
      location: worklocation,
    };

    try {
      if (id) {
        // Update vendor
       const response= await updateVendor({ id, vendorData }).unwrap();
        swal({
          text: response.message,
          icon: "success",
        }).then(() => {
          history.push(Routes.Vendors.path);
        });
      } else {
        // Create vendor
       const response= await createVendor(vendorData).unwrap();
      //  console.log(response)
        swal({
          text: response.message,
          icon: "success",
        })
       
          setVendorName("");
          setPhoneNumber("");
          setCompany("");
          setEmail("");
          setAddress("");
          setPosition("");
          setWorkLocation("");
       
      }
    } catch (error) {
      console.error(error);
      swal({
        text: error.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
     
    }
  };

  const fetchSingleVendor = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getVendor(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setVendorName(response.data?.data?.contact_person);
      setPhoneNumber(response.data?.data?.phone);
      setCompany(response.data?.data?.company_name);
      setEmail(response.data?.data?.email);
      setAddress(response.data?.data?.address);
      setPosition(response.data?.data?.position);
      setWorkLocation(response.data?.data?.location);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleVendor();
  }, [id]);
  const handleBackClick = () => {
    history.push(Routes.Vendors.path);
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-md-0">
              {/* <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Back</Breadcrumb.Item>
            <Breadcrumb.Item active>{id?"Update Vendor":"Create Vendor"}</Breadcrumb.Item>
          </Breadcrumb> */}
              <h4 className="mb-0">Vendors</h4>
            </div>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Card.Title>
                    {id ? "Update Vendor" : "Create a New Vendor"}
                  </Card.Title>

                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="vendorname">
                          <Form.Label>Vendor Name</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Vendor name"
                            value={vendorName}
                            onChange={(e) => setVendorName(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="company">
                          <Form.Label>Company</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Company name"
                            value={company}
                            onChange={(e) => setCompany(e.target.value)}
                            className="custom-placeholder"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="email">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="phone">
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Phone Number"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="options">
                          <Form.Label>Options</Form.Label>
                          <Form.Select
                            value={position}
                            onChange={(e) => setPosition(e.target.value)}
                          >
                            <option value="">Select an option</option>
                            {dropdownItems.map((item) => (
                              <option key={item.value} value={item.value}>
                                {item.name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="location">
                          <Form.Label>Work Location</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Work Location"
                            value={worklocation}
                            onChange={(e) => setWorkLocation(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Col md={12} className="mb-3">
                      <Form.Group id="address">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Enter Address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <div className="d-flex justify-content-between">
                      <Button
                        variant="primary"
                        onClick={handleBackClick}
                        className=" me-2"
                      >
                        <span>Back</span>
                      </Button>
                      {loadingBtn ? (
                        <div className="d-flex justify-content-start">
                          <Loadericon />
                        </div>
                      ) : (
                        <Button
                          variant="primary"
                          type="submit"
                          className=" me-2"
                        >
                          <span>Save</span>
                        </Button>
                      )}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
